import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogActions } from '@angular/material/dialog';
import { OverlayContainer } from '@angular/cdk/overlay';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';


@Component({
    selector: 'app-direct-debit-dialog',
    templateUrl: './direct-debit-dialog.component.html',
    styleUrls: ['./direct-debit-dialog.component.scss'],
    standalone: true,
    imports: [
    MatDialogActions,
    MatProgressSpinner,
    MatButton
],
})
export class DirectDebitComponent implements OnDestroy {
  loading = false;


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<any>,
    public overlayContainer: OverlayContainer
  ) {
    overlayContainer.getContainerElement().classList.add('direct-debit-dialog_overlay');
    overlayContainer.getContainerElement().classList.remove('mini-calendar-dialog_overlay');
  }

  setMobileLayout() {
    this.dialogRef.updateSize('343px');
  }

  setDesktopLayout() {
    this.dialogRef.updateSize('377px');
  }

  noThanks() {
    this.dialogRef.close('no_thanks');
  }

  setupDirectDebit() {
    this.dialogRef.close('setup_direct_debit');
  }

  ngOnDestroy(): void {
    this.overlayContainer.getContainerElement().classList.remove('direct-debit-dialog_overlay');
  }
}
